import { render, staticRenderFns } from "./SafetyConfirmTargetMessageGroupModal.vue?vue&type=template&id=c36dcde2&lang=pug"
import script from "./SafetyConfirmTargetMessageGroupModal.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmTargetMessageGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./SafetyConfirmTargetMessageGroupModal.vue?vue&type=style&index=0&id=c36dcde2&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports